import { ROUTES } from 'constants/constants';

// eslint-disable-next-line import/prefer-default-export
export const ROUTES_EXCEPTIONS: string[] = [
  `${ROUTES.BASE}${ROUTES.ARTICLES}/${ROUTES.ROUTE_ADD}`,
];
